<div class="item">
    <span class="item_title">Previous : </span>
    <span [ngClass]="{'orange-text': params.data[props.previousValue] > params.data[props.afterValue], 'green-text' : params.data[props.previousValue] < params.data[props.afterValue]  }">
        {{params.data[props.previousValue] | number}} {{props.unit}}</span>
</div>
<div class="item">
    <span class="item_title">After : </span>
    <span [ngClass]="{'orange-text': params.data[props.afterValue] > params.data[props.previousValue], 'green-text' : params.data[props.afterValue] < params.data[props.previousValue]  }">
        {{params.data[props.afterValue] | number}} {{props.unit}}</span>
</div>